/**
 * API Error response structure
 * Matches the error format returned by PAP API
 */
export interface ApiError {
  code: string
  message: string
  details?: Record<string, unknown> | undefined
  statusCode: number
}

/**
 * Paginated response structure
 * Used for list endpoints that support pagination
 */
export interface PaginatedResponse<T> {
  data: T[]
  pagination: {
    page: number
    pageSize: number
    totalItems: number
    totalPages: number
    hasNextPage: boolean
    hasPreviousPage: boolean
  }
}

/**
 * Standard API response wrapper
 * All API responses follow this format
 */
export interface ApiResponse<T> {
  success: boolean
  data: T
  error?: ApiError | undefined
}

/**
 * Type guard to check if an error is an ApiError
 */
export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error &&
    'statusCode' in error
  )
}
